import type { PlaybookOption } from "../schemas/playbook-option"

export function playbookChoiceMessage(chosenPlaybook: PlaybookOption): string {
  return `I want to use the playbook "${chosenPlaybook.name}" (id ${chosenPlaybook.id})`
}
